module.exports = __webpack_public_path__ + "img/houseactive.203d2641.svg";